import { render, staticRenderFns } from "./Finalized.vue?vue&type=template&id=444f97aa&scoped=true&"
import script from "./Finalized.vue?vue&type=script&lang=js&"
export * from "./Finalized.vue?vue&type=script&lang=js&"
import style0 from "./Finalized.vue?vue&type=style&index=0&id=444f97aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f97aa",
  null
  
)

export default component.exports